import { MenuDesktopNav, MenuMobileNav, MenuNavUtils  } from "./MenuNav";
import { GenerateMenu } from './MenuNav/GenerateMenu';

const HEADER_FLYOUT = {
    SEARCH_CTA: 'button.search-cta',
    CLOSE_CTA: 'button.close-flyout-cta',
    FLYOUT_SEL: '.search-flyout',
    FLYOUT_SHOW: 'search-flyout--show',
    INPUT_SEARCH: 'input.form__input'
}

const RTI = "Rush Truck Insurance";
const CCFT = "Cummins Clean Fuel Technologies"

const Header = {

  init: function (rootComponent) {
    this.element = rootComponent.querySelector(".main-nav__ctas");
    this.isMegaNav = rootComponent.classList.contains('header--mega');
    this.isDesktop = MenuNavUtils.isDesktopScreenSize();
    this.currMenuInstance = null;
    const localFEDMode = this.element && this.element.dataset && Boolean(this.element.dataset.localFedMode);
    if (localFEDMode) {
      GenerateMenu.generate(this.element, this.isDesktop);
    }
    if (this.isDesktop) {
      this.currMenuInstance = new MenuDesktopNav(this.element, this.isMegaNav);
    } else {
      this.currMenuInstance = new MenuMobileNav(this.element)
    }

    rootComponent.querySelector(".invert").classList.add("search-icon");

    window.addEventListener('resize', this.onWindowResize.bind(this));

    const searchFlyout = rootComponent.querySelector(HEADER_FLYOUT.FLYOUT_SEL);
    const inputSearch = rootComponent.querySelector(HEADER_FLYOUT.INPUT_SEARCH);

    function closeFlyout () {
        searchFlyout && searchFlyout.classList.remove(HEADER_FLYOUT.FLYOUT_SHOW);
        inputSearch && (inputSearch.value = '');
    }
    
    if (searchFlyout) {
        const searchCta = rootComponent.querySelector(HEADER_FLYOUT.SEARCH_CTA);
        const closeCta = rootComponent.querySelector(HEADER_FLYOUT.CLOSE_CTA);

        searchCta && searchCta.addEventListener('click', () => {
            searchFlyout &&
            searchFlyout.classList.contains(HEADER_FLYOUT.FLYOUT_SHOW) ?
                closeFlyout() :
                searchFlyout.classList.add(HEADER_FLYOUT.FLYOUT_SHOW);
        });
        closeCta && closeCta.addEventListener('click', () => {
            closeFlyout();
        });
    }

    if (rootComponent.ariaLabel === RTI) {
      rootComponent.querySelector("a[href='/careers']").target = "_blank";
      rootComponent.querySelector("a[href='/log-in']").target = "_blank";
    }

    if (rootComponent.ariaLabel === CCFT) {
      rootComponent.querySelector("a[href='/customer-support/training-videos']").target = "_blank";
    }
    
  },

  onWindowResize: function (evt) {
    const newIsDesktopState = MenuNavUtils.isDesktopScreenSize();
    if (newIsDesktopState !== this.isDesktop) {
        this.isDesktop = newIsDesktopState;

        if (this.currMenuInstance && this.currMenuInstance.removeListeners) {
          this.currMenuInstance.removeListeners();
        }
        if (this.isDesktop) {
            this.currMenuInstance = new MenuDesktopNav(this.element);
          } else {
            this.currMenuInstance = new MenuMobileNav(this.element)
          }
    }
  }

};

export { Header };
